<template>
  <div class="page2_wrapper">
    <SwiperList :swiperList="swiperList"></SwiperList>
    <div class="container">
      <div class="main">
        <div class="right">
          <div class="breadcrumb">
            <div class="lable">当前位置:</div>
            <div class="breadcrumb_item">
              <div @click="returnPre(0)">首页</div>
              <div @click="returnPre(1)"><span>></span>{{parentActiveTab.label}}</div>
              <!--<div @click="returnPre(2)"><span>></span>{{childActiveTab.label}}</div>-->
            </div>
          </div>
              <home-main></home-main>
          <!--
                修改element样式在element-ui.css文件中修改
                main_list_table_th
                page2_list_table_th
                main_list_table
                -->
          <!-- <div class="list">
            <div class="list main_list_table_th page2_list_table_th">
              <div class="main_list_table">
                <el-table highlight-current-row @cell-click="handleCurrentChange" :data="list" style="width: 100%">
                  <el-table-column prop="pjnoticetitle" label="名称" ></el-table-column>
                  <el-table-column prop="prsflgdesc" label="交易方式" align="center" width="100"></el-table-column>
                  <el-table-column
                      label="倒计时"
                      width="180"
                  >
                    <template slot-scope="scope">
                      <div style="display: flex;justify-content: center">
                      <div v-if="+scope.row.btnstatus < 5 && scope.row.alertmsg">
                        <span>{{scope.row.alertmsg}}</span>
                        <count-down :enddate="scope.row.enddate"></count-down>
                      </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="projectggfbtime" width="200" align="center" label="发布日期"></el-table-column>
                  <el-table-column label="进度/操作" width="130" >
                    <template slot-scope="scope">
                      <div style="display: flex;justify-content: center">
                        <div class="list_btn"
                             :class="{being: scope.row.btnstatus === 2 || scope.row.btnstatus === 4 || scope.row.btnstatus === 5,ended: scope.row.btnstatus > 5}">
                          <div class="button">{{scope.row.btnstatusdesc}}</div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="page">
                <page @pageChanged="pageChanged" :total="total" :currentPage="query.currentPage"
                      :pageSize="pageSize"></page>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  // import Nav from './common/Nav'
  import SwiperList from './common/SwiperList'
  // import CountDown from './common/CountDown'
  // import Page from './common/Page'
  // import _ from 'lodash'
  import request from '@/utils/request'
  import common from '@/mixin/common'
  import HomeMain from '../components/common/HomeMain'
  // import dayjs from 'dayjs'
  export default {
    name: "Project",
    mixins: [common],
    components: {
      SwiperList,HomeMain
    },
    data () {
      return {
        btnLoading: false,
        dialogTitle: '',
        dialogVisible: false,
        dialogWidth: '455px',
        dialogType: 0,
        swiperList: [],
        navs: [],
        total: 0,
        pageSize: 7,
        query: {
          currentPage: 1,
          offset: 0
        },
        list: [],
        activeIndex: '',
        debouncedGetAnswer: '',
        last: '',
        isbmflag: false,
        isbjflag: false,
        project: ''
      }
    },
    created () {
      this.navs = this.parentActiveTab.children
      this.getList()
      this.getSwiperList()
    },
    watch: {
      async $route () {
        this.navs = this.parentActiveTab.children
        await this.getList()
      },
      searchinfo () {
        if (this.searchinfo) {
          this.query.name = this.searchinfo
          this.list = []
          this.getList()
        }
      }
    },
    methods: {
      async getSwiperList () {
        let res = await request({
          method: 'get',
          url: '/web/web/getCarfigList',
          params: {carfigwmenuid: this.parentActiveTab.value, cosid: this.cosId}
        })
        this.swiperList = res
      },
      returnPre (val) {
        // 返回首页
        if (val === 0) {
          this.$router.replace({path: '/'})
        }
      },
      async handleCurrentChange (val) {
        this.project = val
        let {href} = this.$router.resolve({name: 'pjnoticeInfo', query: {pjnoticeid: this.project.pjnoticeid}})
        window.open(href, '_blank')
      },
      async getList () {
        if (this.query.name === '清空') {
          this.query.name = ''
        }
        this.query.limit = this.query.limit ? this.query.limit : this.pageSize
        this.query.cosid = this.cosId
        this.list = []
        let res = await request({
          url: '/web/web/getPageListForWeb',
          method: 'get',
          params: this.query
        })
        this.list = res.list
        this.loading = false
        this.total = res.count.length ? res.count[0].count : 0
      },
      pageChanged (val) {
        this.query.currentPage = val.currentPage
        this.query.limit = val.limit
        this.query.offset = val.offset
        this.getList()
      }
    },
    computed: {
      ...mapGetters(['parentActiveTab', 'childActiveTab', 'cosId', 'webLoginUser', 'obWebUrl', 'picAddr', 'searchinfo'])
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  .pjnoticeCon {
    width: 100%;
  }

  .pjnoticeTitle {
    font-weight: bolder;
    font-size: 20px;
    padding: 30px 0;
    text-align: center;
    border-bottom: 1px solid #ccc;
  }

  .page2_wrapper {
    .container {
      padding: 40px 0;
      display: flex;
      justify-content: center;
      .main {
        width: 1201px;
        display: flex;
        justify-content: center;
        .left {
          background-color: $color-bg-white;
          width: 220px;
          padding: 20px;
          .first_menuname {
            font-weight: bold;
            font-size: $fontsize-large;
            background-color: $color-orange;
            color: #fff;
            padding: 10px 35px;
          }
        }
        .right {
          flex: 1;
          background-color: $color-bg-white;
          margin-left: 15px;
          .breadcrumb {
            padding: 25px 0 10px;
            margin: 0 20px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #FAFAFA;
            .lable {
              padding-right: 10px;
              color: $color-text-secondary-gray;
            }
            .breadcrumb_item {
              display: flex;
              justify-items: center;
              cursor: pointer;
              :last-child {
                color: $color-text-secondary-gray;
                cursor: text;
              }
              span {
                margin: 0 5px;
              }
              .breadcrumb_item_title {
                width: 380px;
                list-style: none;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }
          }
          .content {
            padding: 30px 20px;
            .filename {
              /*width: 500px;*/
              color: #2f74ff;
              cursor: pointer;
            }
          }
          .list {
            padding: 10px;
            .page {
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: $color-bg-white;
              padding: 18px 0;
            }
            .list_btn {
              cursor: pointer;
              color: #FFFFFF;
              display: flex;
              .button {
                text-align: center;
                width: 70px;
                padding: 2px 3px;
                background-color: $color-orange;
              }
            }
            .being {
              .button {
                background-color: $color-being-green;
              }
            }
            .ended {
              .button {
                background-color: $color-orange;
              }
            }
          }
          .simplelist {
            color: $color-dark-gray;
            padding-top: 18px;
            padding-bottom: 50px;
            .simple_item {
              padding: 23px 0 0;
              .text {
                padding-left: 14px;
                padding-right: 23px;
                display: flex;
                /*justify-content: space-between;*/
                align-items: center;
                .icon_jiao {
                  position: relative;
                  left: 22px;
                  top: 13px;
                  width: 0;
                  height: 0;
                  background-color: transparent;
                  border-right: 8px solid transparent;
                  border-left: 0px solid transparent;
                  border-top: 5px solid $color-orange;
                }
                .icon {
                  border-radius: 2px;
                  display: flex;
                  justify-content: center;
                  color: #fff;
                  align-items: center;
                  width: 36px;
                  height: 22px;
                  background-color: $color-orange;
                }
                .title {
                  padding-left: 20px;
                  font-size: $fontsize-large-x;
                  flex: 1;
                }
                .jiantou {
                  cursor: pointer;
                  margin-left: 24px;
                  width: 15px;
                  height: 10px;
                  background-size: 15px 10px;
                  background-image: url("../assets/img/icon_xiajiantou.png");
                }
              }
              .simple_box {
                margin: 23px 22px 0;
                padding-top: 0;
                background-color: $color-bg-gray;
                flex-wrap: wrap;
                .simple_content {
                  line-height: 22px;
                  padding: 12px;
                  width: 920px;
                  word-break: break-all;
                  word-wrap: break-word;
                  overflow-y: auto;
                }
              }
            }
          }
        }
      }
    }
  }
</style>